<template>
  <div>
    <v-layout row>
      <v-flex xs6>
        <v-btn @click="back" flat>
          <v-icon>keyboard_arrow_left</v-icon>
          back
        </v-btn>
      </v-flex>
      <v-flex xs6 style="text-align:right;">
        <v-btn @click="d_edit = true" flat>
          <v-icon>settings</v-icon>
          Settings
        </v-btn>
      </v-flex>
    </v-layout>
    <v-container>
      <h1>{{ p_name }}</h1>
      <p class="enable_new_line">{{ p_description }}</p>
      <h2>Storage</h2>
      <v-layout row wrap v-if="l_buckets" class="spacer_before">
        <v-flex v-for="bucket in buckets" class="list_card_outer" :key="bucket.id" xs12 sm6 md4 lg3>
          <Bucket :id="parseInt(bucket.id)" :name="bucket.name" :project_id="parseInt($route.params.id)" />
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 @click="d_new_bucket = true">
          <AddCard description="New bucket" />
        </v-flex>
      </v-layout>
      <div v-if="!l_buckets">
        <Loading />
      </div>
    </v-container>

    <!-- Dialog for editing projects -->
    <v-dialog
      v-model="d_edit"
      width="500"
    >
      <v-card>
        <v-form @submit="saveEdit">
          <v-card-title
            class="headline"
            primary-title
          >
            Project settings
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="f_name" label="Name" />
            <v-textarea v-model="f_description" label="Description" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              flat
              @click="d_delete = true"
              type="button"
            >
              Delete
            </v-btn>
            <v-btn
              color="primary"
              flat
              type="submit"
              :loading="l_edit_save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog when trying to delete -->
    <v-dialog
      v-model="d_delete"
      width="500"
    >
      <v-card>
        <v-form>
          <v-card-title
            class="headline"
            primary-title
          >
            Delete project
          </v-card-title>

          <v-card-text>
            <p>You are about to delete this project (with all the data like buckets and datasets). Do you really want to continue? This process cannot be undone.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              flat
              @click="d_delete = false"
              type="button"
            >
              Cancel
            </v-btn>
            <v-btn
              color="red"
              flat
              @click="deleteProject"
              type="button"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for adding buckets -->
    <v-dialog
      v-model="d_new_bucket"
      width="500"
    >
      <v-card>
        <v-form @submit="createBucket">
          <v-card-title
            class="headline"
            primary-title
          >
            New bucket
          </v-card-title>

          <v-card-text>
            <v-text-field ref="new_bucket_name" v-model="f_bucket_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              type="submit"
              :loading="l_new_bucket"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Projects } from "../logic/Projects";
import { Buckets } from "../logic/Buckets";

import { Notifications } from "../notification.js";

import Bucket from "../components/project/Bucket.vue";

import Loading from "../components/general/Loading.vue";
import AddCard from "../components/general/AddCard.vue";

export default {
  name: "ProjectDetail",
  data(){
    return {
      //Content
      p_name: "Loading...",
      p_description: "Loading...",
      buckets: [],

      //Loading states
      l_buckets: false,
      l_meta: false,
      l_edit_save: false,
      l_new_bucket: false,

      //Dialog states
      d_edit: false,
      d_delete: false,
      d_new_bucket: false,

      //Form states
      f_name: "",
      f_description: "",
      f_bucket_name: ""
    }
  },
  mounted(){
    var global_this = this;
    var id = this.$route.params.id;
    this.loadProjectMeta(id).then(function(){
      //Set default edit values for edit dialog
      global_this.f_name = global_this.p_name;
      global_this.f_description = global_this.p_description;

      global_this.loadBuckets(id);
    });
  },
  components: {
    Bucket,
    Loading,
    AddCard
  },
  methods: {
    async loadProjectMeta(id){
      var project = await Projects.get(id);

      if(project.status === 200){
        this.p_name = project.body.name;
        this.p_description = project.body.description;
        this.l_meta = true;
      } else if (project.status === 404) {
        Notifications.show("Project has not been found.");
        this.$router.replace("/dashboard");
      }
    },
    async loadBuckets(id){
      var buckets = await Buckets.load(id);
      if(buckets !== undefined){
        this.buckets = buckets.body;
      }
      this.l_buckets = true;
    },
    saveEdit(e){
      e.preventDefault();
      var global_this = this;

      //Perform validation
      this.f_name = this.f_name.trim();
      this.f_description = this.f_description.trim();

      this.l_edit_save = true;

      var project_id = this.$route.params.id;
      Projects.edit(project_id, this.f_name, this.f_description).then(function(response){
        if(response.status === 200){
          Notifications.show(response.message);
          //Move the edited values to the real variables
          global_this.p_name = global_this.f_name;
          global_this.p_description = global_this.f_description;
          global_this.d_edit = false; //Close the dialog
        } else {
          Notifications.show(response.message);
        }
        global_this.l_edit_save = false;
      });
    },
    async deleteProject(){
      var project_id = this.$route.params.id;

      var result = await Projects.delete(project_id);
      if(result.status === 200) {
        Notifications.show(result.message);
        this.$router.replace("/dashboard");
      } else {
        Notifications.show(result.message);
        this.d_delete = false;
      }
    },
    createBucket(e){
      e.preventDefault();

      var global_this = this;

      var project_id = this.$route.params.id;
      this.f_bucket_name = this.f_bucket_name.trim();

      Buckets.create(project_id, this.f_bucket_name).then(function(response){
        if(response.status === 200) {
          Notifications.show("The bucket has been created.");
          global_this.d_new_bucket = false;
          global_this.loadBuckets(project_id);
        } else {
          Notifications.show(response.message);
        }
      });
    },
    back(){
      this.$router.replace("/dashboard");
    }
  },
  watch: {
    d_new_bucket(current){
      var global_this = this;
      if(current){
        setTimeout(function() { global_this.$refs.new_bucket_name.focus(); }, 100);
      }
    }
  }
}
</script>
